<template>
	<div class="selectSeal">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center :close-on-click-modal="false">
			<div class="center">
				 <el-transfer :titles="['未绑定列表', '已绑定列表']" filterable :props="{key: 'deviceId',label: 'name'}" v-model="dialog.selectList" :data="dialog.dataList">
					<div slot-scope="{ option }">{{ option.name }} <el-tag :type="option.online?'success':'warning'" size="mini" style="margin-left: 5px;">{{option.online?'在线':'离线'}}</el-tag></div>
				 </el-transfer>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelFn">取 消</el-button>
				<el-button type="primary" @click="bindFn">确 定</el-button>
			</span>
		</el-dialog>
		
		
	</div>
</template>

<script>
	let that 
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api','documentTypeList']),
			//计算证件类型
			computerDocumentType(){
				return (code)=>{
					let item= this.documentTypeList.find(item=>item.value==code)
					return item.label
				}
			}
		},
		name: 'selectSignatory',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			title: {
				type: String,
				default: '选择'
			},
			hspaDeviceId:{
				type: String,
				default: ''
			},
		},
		data() {
			return {
				dialog:{
					show:false,
					selectList:[],//已选择的设备列表
					dataList:[],//全部设备列表
				},
			}
		},
		mounted() {
			that =this
		},
		methods: {
			bindFn(){
				let req={
					emulateJSON:false,// emulateJSON为前端需要参数
					deviceIds:this.dialog.selectList,
					hspaDeviceId:this.hspaDeviceId,
				}
				that.GLOBAL.doPost(this.api.GLOBAL_tenant_hspa_device_bind,req,(res)=>{
					if(res.code==200){
						this.$message.success(res.msg)
						this.cancelFn()
					}
				})
			},
			cancelFn(){
				this.dialog.show=false
				this.cancel()
			},
			show(data){
				this.dialog.show=true
				//已绑定的设备列表
				this.queryBindSignetList()
				//待绑定印章设备列表
				this.bindSignetListFn()
				
			},
			//已绑定的设备列表
			queryBindSignetList(){
				let req={
					hspaDeviceId:this.hspaDeviceId
				}
				that.GLOBAL.doGet(this.api.GLOBAL_tenant_hspa_device_queryBindSignets,req,(res)=>{
					if(res.code==200&&res.data){
						this.dialog.selectList=res.data.map(item=>item.deviceId)
					}else{
						this.dialog.selectList=[]
					}
				})
			
			},
			//待绑定印章设备列表
			bindSignetListFn(){
				let req={}
				that.GLOBAL.doGet(this.api.GLOBAL_tenant_hspa_device_querySignetList,req,(res)=>{
					if(res.code==200&&res.data){
						this.dialog.dataList=res.data
					}else{
						this.dialog.dataList=[]
					}
				})
			},
			handclose(){
				this.close()
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body{
		padding:20px 20px 0px
	}
	/deep/ .lz-input .el-input__inner{
		border-color: red;
	}
	/deep/ .el-checkbox:last-of-type{
		margin-right: 10px 
	}
	/deep/ .el-transfer-panel{
		width:260px;
	}
	/deep/ .el-transfer__buttons{
		padding:0 10px;
	}
	/deep/ .el-transfer-panel__body{
		height: 370px;
	}
	/deep/ .el-transfer-panel__list{
		height: 100%;
	}
	@import './selectSeal.scss';	
</style>



// WEBPACK FOOTER //
// src/components/selectSeal/selectSeal.vue